import { Link } from 'react-router';
import { SITE } from '~/data/site';
import { Lockup } from '~/components/brand/lockup';
import { shippedServices } from '~/data/services';
import { shippedIndustries } from '~/data/industries';
import { CITIES } from '~/data/cities';

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="shell">
        <div className="footer-grid">
          <div>
            <h4>Services</h4>
            <ul>
              {shippedServices().map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`}>{s.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Industries</h4>
            <ul>
              {shippedIndustries().map((i) => (
                <li key={i.slug}>
                  <Link to={`/industries/${i.slug}`}>{i.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sitewide links to the city pages. The footer is how a page on the far
              side of the site still sits two clicks from every city page — which is
              what keeps them crawled and stops them reading as a dead-end branch. */}
          <div>
            <h4>Service areas</h4>
            <ul>
              {CITIES.map((c) => (
                <li key={c.slug}>
                  <Link to={`/commercial-cleaning/${c.slug}`}>{c.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/why-us">Why us</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/service-area">Service area</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Get in touch</h4>
            <ul>
              <li>
                <a href={`mailto:${SITE.contact.email}`}>{SITE.contact.email}</a>
              </li>
              <li>{SITE.contact.address}</li>
              <li className="small" style={{ color: 'var(--night-slate)' }}>
                {SITE.hours.service}
              </li>
            </ul>
          </div>

          {/*
            The three portals. Plain <a> — every one of these leaves this domain
            for the console at ssc.broomstack.app, and a <Link> would have React
            Router try to match it as an internal route and 404.

            The footer is the right home for the full set. The header carries one
            "Log in" for the common case; someone hunting for a crew or client
            portal specifically looks down here, and that ordering keeps the
            header from making every visitor pick a door they do not need.
          */}
          <div>
            <h4>Log in</h4>
            <ul>
              <li>
                <a href={SITE.console.admin}>Owners &amp; managers</a>
              </li>
              <li>
                <a href={SITE.console.team}>Crew</a>
              </li>
              <li>
                <a href={SITE.console.client}>Clients</a>
              </li>
            </ul>
          </div>
        </div>

        {/*
          Hiring. It sits between the columns and the copyright because that is
          where someone who came here to work — not to buy — ends up scrolling,
          and it is a button rather than a list item because it is the only
          action in the footer we actually want taken.
        */}
        <div className="footer-hire">
          <div>
            <h4>Join the team</h4>
            <p className="small">
              Evening and overnight cleaning across {SITE.serviceArea}. We train, we supply the
              equipment, and a person reads every application.
            </p>
          </div>
          <Link to="/apply" className="btn btn-on-night">
            Apply to join the team
          </Link>
        </div>

        {/* The full primary lockup, one place on the site where it runs at a size the
            board's amber descriptor is actually legible (the header is far below that
            floor and drops it). Mark, wordmark, spruce rule, COMMERCIAL CLEANING —
            exactly the stack on the delivered board. */}
        <div className="footer-lockup">
          <Lockup height={96} showDescriptor />
        </div>

        <div className="footer-bottom">
          <p>
            © {year} {SITE.name}. Commercial cleaning across {SITE.serviceArea}.
          </p>
          <p>NAICS {SITE.naics}</p>
        </div>
      </div>
    </footer>
  );
}
